export default __webpack_public_path__ + "static/media/icn-wtd-braking-distance.224fbe3a.svg";